export const getCalendarPageSteps = (t) => [
    {
        target: 'body',
        placement: 'center',
        title: t('tour.calendarPage.step-welcome-title'),
        content: t('tour.calendarPage.step-welcome-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="cal-filters"]',
        title: t('tour.calendarPage.step-filters-title'),
        content: t('tour.calendarPage.step-filters-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="cal-grid"]',
        placement: 'center-left',
        title: t('tour.calendarPage.step-grid-title'),
        content: t('tour.calendarPage.step-grid-content'),
        disableBeacon: true,
    },
    {
        target: 'body',
        placement: 'center',
        title: t('tour.calendarPage.step-sync-title'),
        content: t('tour.calendarPage.step-sync-content'),
        disableBeacon: true,
    },
];
